// configuration dependencies
import environment from "../environment";
import localRepository from "../localRepository";
import fetchRetry from "../libs/fetch-retry";
import { withCorrelation } from "../libs/correlationId";

import {
  parseError,
  errorUnlessOk,
  buildRequest,
  createBuildRequestWithAuth,
} from "./utils";

import {
  createPostChangeRequest,
  createGetChangeRequest,
} from "./pedidoCambioApiFactories";

import {
  createGetProvinciasCodigosPostales,
  createGetProvinciasLocalidades,
} from "./provinciasApiFactories";

import { createGetCanales } from "./canalesApiFactories";

import {
  createGetVehiclesMarcas,
  createGetVehiclesVersiones,
  createGetVehiclesPrice,
  createGetVehicleReferencePrice,
} from "./vehiclesApiFactories";

import {
  createPostContacto,
  createDeleteTelefono,
  createPostContactoConsumo,
  createPostEmailConsumo,
} from "./contactoApiFactories";

import { createGetCalculadorResult } from "./calculadorApiFactories";
import { createGetCalculadorConsumoResult } from "./calculadorConsumoApiFactories";

import {
  createPostSolicitudNueva,
  createPostContinuarSolicitud,
  createPostSolicitudIngresos,
  createPostSolicitudDomicilioTitular,
  createPostSolicitudAuto,
  createPostSolicitudImporte,
  createPostSolicitudSeguroCotizacion,
  createGetEstadoCalificacion,
  createGetOfertas,
  createPostSolicitudSeleccionOferta,
  createPostSolicitudCerrarSinOferta,
  createGetSolicitudes,
  createGetSolicitudById,
  createGetSolicitudSegurosInicio,
  createGetSolicitudSegurosResult,
  createGetPlazosPrestamo,
  createPostSolicitarConfeccionPrenda,
} from "./solicitudesApiFactories";

import {
  createPostSolicitudConsumoNueva,
  createPostDesistirSolicitudConsumo,
  createPostSolicitudConsumoDomicilio,
  createPostTitularRegistralConsumo,
  createPostDictamenConsumo,
  createGetOfertasConsumo,
  createPostSolicitudConsumoSeleccionOferta,
  createUploadTicketConsumo,
  createInicioFirma,
  createVerificarFirma,
  createGetSolicitudConsumoById,
  createGetTelefonosSolicitudConsumoById,
  createReenviarSMS,
  createGenerarResumenPrestamo,
} from "./solicitudesConsumoApiFactories";

import {
  createPostReporteConsumo,
  createGetCadenasReporte,
} from "./reporteConsumo";

import {
  createGetTareasSolicitud,
  createPostTarea,
  createPostTareaConyuge,
  createPostTareaCodeudor,
  createPostTareaTelefono,
} from "./tareasApiFactories";

import { createGetIdentidad } from "./creditRiskApiFactories";

import {
  createGetSegurosCotizaciones,
  createPostSegurosCotizar,
  createPostSegurosQuieroQueMeContacten,
} from "./segurosFactories";

import {
  createPostSignupAgencia,
} from "./signupAgenciasFactories";

import { createPostSignupClienteFinal } from "./signupClienteFInalFactories";
import { createPostSignupProductor } from "./signupProductorFactories";

import {
  createPostRecoverPassword,
  createSessionLogin,
  createSessionSendRecoveryPasswordEmail,
  createPostVincularOperaciones,
} from "./userApiFactories";

import {
  createGetAceptacion,
  createPostAceptarTerminos,
} from "./terminosYCondicionesApiFactories";
import { createGetUserExists } from "./authApiFactories";

import {
  createGetCreditosVigentes,
  createGetDetalleCredito,
  createGetCuotasCredito,
  createGetCuponesCredito,
  createGetComprobantesPago,
  createGetComprobanteCreditoAlDia,
  createGetCuponPagoSaldo,
  createGetNotaCancelacion,
  createPostInformarPago,
} from "./creditosApiFactories";

import {
  createGetPolizas,
  createGetDetallePoliza,
  createGetPolizaFile,
  createGetTarjetaMercosur,
} from "./segurosApiFactories";

import { createPostQuieroQueMeContacten } from "./quieroQueMeContactenApiFactories";

import {
  createInicioFirmaPrendario,
  createConsultarEstadoFirmaPrendario,
  createReenviarInvitacionPrendario,
} from "./firmaPrendarioApiFactories";

// dependecies injection

const buildRequestWithAuth = createBuildRequestWithAuth({ localRepository });

const sessionLogin = createSessionLogin({
  fetch: window.fetch,
  environment,
  buildRequest,
  errorUnlessOk,
});
const sessionSendRecoveryPasswordEmail = createSessionSendRecoveryPasswordEmail(
  { fetch: window.fetch, environment, buildRequest, errorUnlessOk }
);

let [
  getCanales,
  getProvinciasCodigosPostales,
  getProvinciasLocalidades,
  getIdentidad,
  postSolicitudNueva,
  postSolicitudConsumoNueva,
  postDesistirSolicitudConsumo,
  postSolicitudConsumoDomicilio,
  postTitularRegistralConsumo,
  postDictamenConsumo,
  getOfertasConsumo,
  postSolicitudConsumoSeleccionOferta,
  uploadTicketConsumo,
  inicioFirma,
  postContinuarSolicitud,
  postSolicitudIngresos,
  postSolicitudDomicilioTitular,
  postSolicitudImporte,
  postSolicitudAuto,
  postSolicitudSeguroCotizacion,
  getEstadoCalificacion,
  getOfertas,
  postSolicitudSeleccionOferta,
  postSolicitudCerrarSinOferta,
  getSolicitudes,
  getSolicitudById,
  getSolicitudConsumoById,
  getTelefonosSolicitudConsumoById,
  generarResumenPrestamo,
  verificarFirma,
  reenviarSMS,
  getCalculadorResult,
  getCalculadorConsumoResult,
  postContacto,
  deleteTelefono,
  postContactoConsumo,
  postEmailConsumo,
  postReporteConsumo,
  getCadenasReporte,
  getTareasSolicitud,
  postTarea,
  postTareaConyuge,
  postTareaCodeudor,
  postTareaTelefono,
  postChangeRequest,
  postSignupAgencia,
  postRecoverPassword,
  getchangeRequests,
  getSegurosCotizaciones,
  postSegurosCotizar,
  patchSegurosQuieroQueMeContacten,
  getSolicitudSegurosInicio,
  getSolicitudSegurosResult,
  getAceptacion,
  postAceptarTerminos,
  getPlazosPrestamo,
  getUserExists,
  getCreditosVigentes,
  getDetalleCredito,
  getCuotasCredito,
  getCuponesCredito,
  getComprobantesPago,
  getComprobanteCreditoAlDia,
  getCuponPagoSaldo,
  getNotaCancelacion,
  getPolizas,
  getDetallePoliza,
  getTarjetaMercosur,
  postInformarPago,
  getPolizaFile,
  postSignupClienteFinal,
  postSignupProductor,
  postVincularOperaciones,
  postQuieroQueMeContacten,
  getVehiclesMarcas,
  getVehiclesVersiones,
  getVehiclesPrice,
  getVehicleReferencePrice,
  postSolicitarConfeccionPrenda,
  postInicioFirmaPrendario,
  getEstadoFirmaPrendario,
  postReenviarInvitacionPrendario,
] = [
  createGetCanales,
  createGetProvinciasCodigosPostales,
  createGetProvinciasLocalidades,
  createGetIdentidad,
  createPostSolicitudNueva,
  createPostSolicitudConsumoNueva,
  createPostDesistirSolicitudConsumo,
  createPostSolicitudConsumoDomicilio,
  createPostTitularRegistralConsumo,
  createPostDictamenConsumo,
  createGetOfertasConsumo,
  createPostSolicitudConsumoSeleccionOferta,
  createUploadTicketConsumo,
  createInicioFirma,
  createPostContinuarSolicitud,
  createPostSolicitudIngresos,
  createPostSolicitudDomicilioTitular,
  createPostSolicitudImporte,
  createPostSolicitudAuto,
  createPostSolicitudSeguroCotizacion,
  createGetEstadoCalificacion,
  createGetOfertas,
  createPostSolicitudSeleccionOferta,
  createPostSolicitudCerrarSinOferta,
  createGetSolicitudes,
  createGetSolicitudById,
  createGetSolicitudConsumoById,
  createGetTelefonosSolicitudConsumoById,
  createGenerarResumenPrestamo,
  createVerificarFirma,
  createReenviarSMS,
  createGetCalculadorResult,
  createGetCalculadorConsumoResult,
  createPostContacto,
  createDeleteTelefono,
  createPostContactoConsumo,
  createPostEmailConsumo,
  createPostReporteConsumo,
  createGetCadenasReporte,
  createGetTareasSolicitud,
  createPostTarea,
  createPostTareaConyuge,
  createPostTareaCodeudor,
  createPostTareaTelefono,
  createPostChangeRequest,
  createPostSignupAgencia,
  createPostRecoverPassword,
  createGetChangeRequest,
  createGetSegurosCotizaciones,
  createPostSegurosCotizar,
  createPostSegurosQuieroQueMeContacten,
  createGetSolicitudSegurosInicio,
  createGetSolicitudSegurosResult,
  createGetAceptacion,
  createPostAceptarTerminos,
  createGetPlazosPrestamo,
  createGetUserExists,
  createGetCreditosVigentes,
  createGetDetalleCredito,
  createGetCuotasCredito,
  createGetCuponesCredito,
  createGetComprobantesPago,
  createGetComprobanteCreditoAlDia,
  createGetCuponPagoSaldo,
  createGetNotaCancelacion,
  createGetPolizas,
  createGetDetallePoliza,
  createGetTarjetaMercosur,
  createPostInformarPago,
  createGetPolizaFile,
  createPostSignupClienteFinal,
  createPostSignupProductor,
  createPostVincularOperaciones,
  createPostQuieroQueMeContacten,
  createGetVehiclesMarcas,
  createGetVehiclesVersiones,
  createGetVehiclesPrice,
  createGetVehicleReferencePrice,
  createPostSolicitarConfeccionPrenda,
  createInicioFirmaPrendario,
  createConsultarEstadoFirmaPrendario,
  createReenviarInvitacionPrendario,
].map((factory) =>
  factory({
    fetch: withCorrelation(fetchRetry),
    environment,
    buildRequestWithAuth,
    errorUnlessOk,
    parseError,
    localRepository,
  })
);

export {
  sessionLogin,
  sessionSendRecoveryPasswordEmail,
  getCanales,
  getProvinciasCodigosPostales,
  getProvinciasLocalidades,
  getIdentidad,
  postSolicitudNueva,
  postSolicitudConsumoNueva,
  postDesistirSolicitudConsumo,
  postSolicitudConsumoDomicilio,
  postTitularRegistralConsumo,
  postDictamenConsumo,
  getOfertasConsumo,
  createPostSolicitudConsumoSeleccionOferta,
  postSolicitudConsumoSeleccionOferta,
  uploadTicketConsumo,
  postContinuarSolicitud,
  postSolicitudIngresos,
  postSolicitudDomicilioTitular,
  postSolicitudAuto,
  postSolicitudImporte,
  postSolicitudSeguroCotizacion,
  getEstadoCalificacion,
  getOfertas,
  postSolicitudSeleccionOferta,
  postSolicitudCerrarSinOferta,
  getSolicitudes,
  getSolicitudById,
  getSolicitudConsumoById,
  getTelefonosSolicitudConsumoById,
  generarResumenPrestamo,
  inicioFirma,
  verificarFirma,
  reenviarSMS,
  getCalculadorResult,
  getCalculadorConsumoResult,
  postContacto,
  deleteTelefono,
  postContactoConsumo,
  postEmailConsumo,
  postReporteConsumo,
  getCadenasReporte,
  getTareasSolicitud,
  postTarea,
  postTareaConyuge,
  postTareaCodeudor,
  postTareaTelefono,
  postChangeRequest,
  postSignupAgencia,
  postRecoverPassword,
  getchangeRequests,
  getSegurosCotizaciones,
  postSegurosCotizar,
  patchSegurosQuieroQueMeContacten,
  getSolicitudSegurosInicio,
  getSolicitudSegurosResult,
  getAceptacion,
  postAceptarTerminos,
  getPlazosPrestamo,
  buildRequestWithAuth,
  getUserExists,
  getCreditosVigentes,
  getDetalleCredito,
  getCuotasCredito,
  getCuponesCredito,
  getComprobantesPago,
  getComprobanteCreditoAlDia,
  getCuponPagoSaldo,
  getNotaCancelacion,
  getPolizas,
  getDetallePoliza,
  getTarjetaMercosur,
  postInformarPago,
  getPolizaFile,
  postSignupClienteFinal,
  postSignupProductor,
  postVincularOperaciones,
  postQuieroQueMeContacten,
  getVehiclesMarcas,
  getVehiclesVersiones,
  getVehiclesPrice,
  getVehicleReferencePrice,
  postSolicitarConfeccionPrenda,
  postInicioFirmaPrendario,
  getEstadoFirmaPrendario,
  postReenviarInvitacionPrendario,
};
